/**
 * @generated SignedSource<<f25e6a6dcc65038d173741b6ce450d87>>
 * @relayHash 49305712d5c2ee4a166ee8959ccffba3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 7297be0833aa2fe00284f4600e5b5ba7c832ea39e0abaa462138bfd25cb340d7

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type StakeholderCommsSearchField = "EMAIL_ID" | "%future added value";
export type StakeholderCommsStakeholderStatus = "ACTIVE" | "DELETED" | "QUARANTINED" | "%future added value";
export type StakeholderCommsStakeholderType = "EXTERNAL" | "INTERNAL" | "TEAM" | "%future added value";
export type StakeholderCommsStakeholderConnectionFilter = {
  status?: ReadonlyArray<StakeholderCommsStakeholderStatus> | null | undefined;
  type?: ReadonlyArray<StakeholderCommsStakeholderType> | null | undefined;
};
export type StakeholderCommsStakeholderConnectionSearch = {
  searchField?: StakeholderCommsSearchField | null | undefined;
  searchValue?: string | null | undefined;
};
export type StakeholdersPageQuery$variables = {
  after?: string | null | undefined;
  filter?: StakeholderCommsStakeholderConnectionFilter | null | undefined;
  first: number;
  search?: StakeholderCommsStakeholderConnectionSearch | null | undefined;
};
export type StakeholdersPageQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"StakeholderPageContent">;
};
export type StakeholdersPageQuery = {
  response: StakeholdersPageQuery$data;
  variables: StakeholdersPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filter"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "search"
},
v4 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "filter",
    "variableName": "filter"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "search",
    "variableName": "search"
  }
],
v5 = {
  "kind": "ScalarField",
  "name": "id"
},
v6 = {
  "kind": "ScalarField",
  "name": "name"
},
v7 = {
  "kind": "ScalarField",
  "name": "avatar"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "StakeholdersPageQuery",
    "selections": [
      {
        "kind": "FragmentSpread",
        "name": "StakeholderPageContent"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "StakeholdersPageQuery",
    "selections": [
      {
        "args": (v4/*: any*/),
        "concreteType": "StakeholderCommsStakeholderConnection",
        "kind": "LinkedField",
        "name": "stakeholderComms_listStakeholders",
        "plural": false,
        "selections": [
          {
            "concreteType": "StakeholderCommsStakeholderEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "StakeholderCommsStakeholder",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  {
                    "concreteType": "StakeholderCommsNotificationPreference",
                    "kind": "LinkedField",
                    "name": "notificationPreference",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "emailId"
                      },
                      (v5/*: any*/)
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "status"
                  },
                  {
                    "concreteType": "StakeholderCommsGroups",
                    "kind": "LinkedField",
                    "name": "groups",
                    "plural": true,
                    "selections": [
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/)
                    ]
                  },
                  (v6/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "type"
                  },
                  (v7/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "__typename"
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "cursor"
              }
            ]
          },
          {
            "concreteType": "StakeholderCommsPageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "hasNextPage"
              },
              {
                "kind": "ScalarField",
                "name": "endCursor"
              }
            ]
          }
        ]
      },
      {
        "args": (v4/*: any*/),
        "filters": [
          "filter",
          "search"
        ],
        "handle": "connection",
        "key": "StakeholderTableLayout_stakeholderComms_listStakeholders",
        "kind": "LinkedHandle",
        "name": "stakeholderComms_listStakeholders"
      }
    ]
  },
  "params": {
    "id": "7297be0833aa2fe00284f4600e5b5ba7c832ea39e0abaa462138bfd25cb340d7",
    "metadata": {},
    "name": "StakeholdersPageQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "5d2fcc256d3d69fa8469975de7d26375";

export default node;
